import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="bg-blue-900 rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-3">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-20" data-id="element-4">
            <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-red-600 blur-3xl" data-id="element-5"></div>
            <div className="absolute -left-20 -bottom-20 w-96 h-96 rounded-full bg-blue-400 blur-3xl" data-id="element-6"></div>
          </div>

          <div className="relative z-10 px-8 py-16 md:py-20 text-center" data-id="element-7">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-8">
              Ready to Start Your Project?
            </h2>
            <p className="text-lg text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-9">
              Get a free quote today. No hidden fees, just premium quality
              printing and exceptional service.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-10">
              <Button size="lg" className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg shadow-lg shadow-red-900/20" data-id="element-11">
                Get Quote Now
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-12" />
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 text-lg" data-id="element-13">
                Contact Sales
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}